/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import Image from 'next/legacy/image';
import styled from 'styled-components';
import type { CMSImage } from '~/networking/api/cms/responses/CMSWineVintage';
import { defaultBottleImage } from '~/stores/wineConstants';

interface ProductImageProps {
    productImageUrl?: CMSImage;
    displayName?: string;
    vintage?: string | number;
}

const ProductImage: React.FC<ProductImageProps> = ({ productImageUrl, displayName, vintage }) => (
    <ProductImageWrapper>
        <Image
            src={`${productImageUrl?.url || defaultBottleImage}`}
            width={235}
            height={517}
            alt={`${displayName} ${vintage}`}
            loading={'eager'}
        />
    </ProductImageWrapper>
);

export default ProductImage;

export const ProductImageWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    position: relative;
    top: -60px;
    @media screen and (max-width: 767px) {
        width: 150px;
        height: 330px;
        display: flex;
        justify-content: space-around;
        position: relative;
        top: -60px;
    }
`;
